<template>
  <div class="containerTable">
    <vxe-toolbar id="toolbarId_ca9" :custom="{storage: true}" export :refresh="{query: findList}">
      <template v-slot:buttons>
        <el-button v-if="userOil_search_button" @click="findList">
          查询
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      :sort-config="{ remote: true }"
      show-overflow
      export-config
      align="center"
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      :checkbox-config="{highlight: true, strict: true }"
      :expand-config="{accordion: true}"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column type="expand" width="80">
        <template #content="{ row }">
          <div class="expand-wrapper" style="width:90%;margin:0 auto;">
            <vxe-table
              border
              :data="row.accountList"
            >
              <vxe-table-column field="cuId" title="账户ID" />
              <vxe-table-column field="fuelType" title="油品类型" />
              <vxe-table-column field="fuelMoney" title="余额(元)">
                <template v-slot="{row}">
                  {{ row.fuelMoney+'' }}
                </template>
              </vxe-table-column>
              <vxe-table-column field="actId" title="资金品类账户" />
              <vxe-table-column field="defaultAccount" title="是否默认储值账户" />
            </vxe-table>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="companyName" title="公司名称" min-width="260" />
      <vxe-table-column field="receiptCode" title="信用代码" min-width="260" />
      <vxe-table-column field="zzNumber" title="万金油账户" min-width="200" />
      <vxe-table-column field="totalFuelAmount" title="总余额(元)" min-width="200" />
    </vxe-table>
  </div>
</template>
<script>
import { getAuthorizeCompany }  from '@/api/userOil'
export default {
  data() {
    return {
      loading: false,
      userOil_search_button: false, //查询
      userOil_sumMoney_button: false, //企业总余额
      userOil_oilMoney_button: false, //企业柴油可用余额
      userOil_lngMoney_button: false, //企业天然气可用余额
      tableData: [],
      moneyArr: '',
      branchCode: this.$store.state.user.party.branchCode,
      userTypeOptions:{
        '1':'储值账户',
        '2':'信用卡账户',
        '3':'入账账户',
        '4':'返点账户',
        '5':'体验金账户',
      },
      categoryOptions:{
        '1':'柴油',
        '2':'天然气'
      },
      listQuery:{
        page:1, 
        pageSize: 500,
        receiptCode:'',
        branchCode: this.$store.state.user.party.branchCode
      }
    }
  },
  created() {
    this.findList()
    this.userOil_search_button = this.getLimit('userOil_search_button')
    this.userOil_sumMoney_button = this.getLimit('userOil_sumMoney_button')
    this.userOil_oilMoney_button = this.getLimit('userOil_oilMoney_button')
    this.userOil_lngMoney_button = this.getLimit('userOil_lngMoney_button')
  },
  methods: {
    findList() {
      this.loading = true
      return new Promise((resolve) => {
        getAuthorizeCompany(this.listQuery).then((response) => {
          this.tableData = response.data.authorizeCompanyList
          resolve()
        }).finally(() => {
          this.loading = false
        })
      })
    },
  }
}
</script>
